import { HasuraQueries } from "@/api/hasura/queries"
import { useQuery } from "@/api/utils/useQuery"
import { QueryResult } from "@/api/utils/types"
import { ISmartChargingEligibility } from "@/models/operations/smartCharging/smartChargingEligibility/smartChargingEligibility.types"
import { SmartChargingEligibilityParser } from "@/models/operations/smartCharging/smartChargingEligibility/smartChargingEligibility.parser"
import { ISmartChargingAccount } from "@/models/operations/smartCharging/smartChargingAccount/smartChargingAccount.types"
import { SmartChargingAccountParser } from "@/models/operations/smartCharging/smartChargingAccount/smartChargingAccount.parser"

class SmartChargingServiceClass {
  getWaitlistAccountIds(): QueryResult<number[]> {
    return useQuery({
      ...HasuraQueries.smartCharging.waitlist,
      placeholderData: [] as number[],
      useRawResponse: true,
      parserFn: (data) =>
        (data?.ev_smart_tariff_waitlist ?? []).map((row) =>
          Number(row.billing_account_id),
        ),
    })
  }

  getEligibilityBreakdown(): QueryResult<ISmartChargingEligibility> {
    const empty: ISmartChargingEligibility = {
      total: 0,
      compatible: 0,
      compatibleAccountIds: [],
      chargers: [],
      evs: [],
    }
    return useQuery({
      ...HasuraQueries.smartCharging.eligibilityChecks,
      placeholderData: empty,
      useRawResponse: true,
      parserFn: (data) =>
        data ? SmartChargingEligibilityParser.toDomain(data) : empty,
    })
  }

  getAccounts(): QueryResult<ISmartChargingAccount[]> {
    return useQuery({
      ...HasuraQueries.smartCharging.accounts,
      placeholderData: [] as ISmartChargingAccount[],
      useRawResponse: true,
      parserFn: (data) =>
        (data?.smart_charging ?? []).map(SmartChargingAccountParser.toDomain),
    })
  }
}

export const SmartChargingService = new SmartChargingServiceClass()
